import { render, staticRenderFns } from "./SchoolUserInfoForm.vue?vue&type=template&id=dbaa76cc"
import script from "./SchoolUserInfoForm.vue?vue&type=script&lang=js"
export * from "./SchoolUserInfoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dbaa76cc')) {
      api.createRecord('dbaa76cc', component.options)
    } else {
      api.reload('dbaa76cc', component.options)
    }
    module.hot.accept("./SchoolUserInfoForm.vue?vue&type=template&id=dbaa76cc", function () {
      api.rerender('dbaa76cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/schoolUserInfo/modules/SchoolUserInfoForm.vue"
export default component.exports